import { useCallback, useEffect, useState } from "react";
import { BarChart3, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Field, Card } from "@/components/admin/CmsFields";

export const SeoEditor = ({ s, set }) => (
  <Card title="SEO ayarları (ana sayfa)" testid="cms-seo">
    <Field label="Sayfa başlığı (boş = mevcut başlık)" value={s.title} max={70} onChange={(v) => set({ title: v })} testid="cms-seo-title" hint={`${s.title.length}/70 · Arama sonuçlarında görünür`} />
    <Field label="Açıklama (boş = mevcut açıklama)" area value={s.description} max={170} onChange={(v) => set({ description: v })} testid="cms-seo-description" hint={`${s.description.length}/170`} />
    <Field label="Paylaşım görseli (https:// adresi, ops.)" value={s.og_image_url} max={500} onChange={(v) => set({ og_image_url: v })} testid="cms-seo-og-image" />
    <p className="text-[11px] text-muted-foreground">Görünür SSS bölümleri arama motorları için otomatik olarak soru-cevap yapısal verisine eklenir.</p>
  </Card>
);

export const AdStats = () => {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => { api.get("/admin/cms/ads/stats").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <Card testid="cms-ad-stats" title={<span className="flex items-center gap-1"><BarChart3 className="w-4 h-4" />Reklam istatistikleri</span>}
      right={<Button size="icon" variant="ghost" className="h-7 w-7" onClick={load} data-testid="cms-ad-stats-refresh"><RefreshCw className="w-4 h-4" /></Button>}>
      {rows === null && <div className="text-sm text-muted-foreground">Yükleniyor…</div>}
      {rows?.length === 0 && <div className="text-sm text-muted-foreground">Henüz reklam yok.</div>}
      {rows?.map((a) => (
        <div key={a.ad_id} className="rounded-xl bg-muted/30 p-3 text-sm space-y-1" data-testid={`cms-ad-stat-${a.ad_id}`}>
          <div className="font-medium truncate">{a.label || "Silinmiş reklam"}</div>
          <div className="grid grid-cols-3 gap-2 text-center">
            <div><div className="text-lg font-bold" data-testid={`cms-ad-stat-impressions-${a.ad_id}`}>{a.impressions}</div><div className="text-[11px] text-muted-foreground">Gösterim</div></div>
            <div><div className="text-lg font-bold" data-testid={`cms-ad-stat-clicks-${a.ad_id}`}>{a.clicks}</div><div className="text-[11px] text-muted-foreground">Tıklama</div></div>
            <div><div className="text-lg font-bold" data-testid={`cms-ad-stat-ctr-${a.ad_id}`}>%{a.ctr}</div><div className="text-[11px] text-muted-foreground">Tıklama oranı</div></div>
          </div>
          {a.days.length > 0 && <details className="text-xs"><summary className="cursor-pointer text-muted-foreground">Son 30 gün</summary>
            {a.days.map((d) => <div key={d.day} className="flex justify-between py-0.5"><span>{d.day}</span><span>{d.impressions} gösterim · {d.clicks} tıklama</span></div>)}
          </details>}
        </div>
      ))}
      <p className="text-[11px] text-muted-foreground">Aynı ziyaretçinin tekrarları sayılmaz (gösterim saatte 1, tıklama 10 dakikada 1). Önizleme sayılmaz.</p>
    </Card>
  );
};
